import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_256: DocMigration = {
  maxSchemaVersion: "0.0.256",
  description: "Migrates stair area first floor only to area report settings",
  apply(json: any) {
    if (json.settings) {
      for (const settingId of Object.keys(json.settings)) {
        const planSettings = json.settings[settingId];
        if (planSettings.type !== "PLAN_SETTINGS") {
          continue;
        }

        const stairAreaFirstFloorOnly = planSettings.stairAreaFirstFloorOnly;
        if (stairAreaFirstFloorOnly === undefined) {
          continue;
        }

        let areaReportSettings = planSettings.areaReportSettings;
        if (areaReportSettings === undefined) {
          areaReportSettings = {};
        }
        if (areaReportSettings["CONDITIONED_FLOOR_AREA"] === undefined) {
          areaReportSettings["CONDITIONED_FLOOR_AREA"] = {};
        }

        areaReportSettings["CONDITIONED_FLOOR_AREA"].stairAreaFirstFloorOnly = stairAreaFirstFloorOnly;

        delete planSettings.stairAreaFirstFloorOnly;

        planSettings.areaReportSettings = areaReportSettings;

        json.settings[settingId] = planSettings;
      }
    }
    return json;
  },
};

export default migration_0_0_256;
